import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fa5bb71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between mb-7" }
const _hoisted_3 = { class: "flex justify-start" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "relative h-42 w-288 me-3" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex justify-end mb-2 relative" }
const _hoisted_9 = {
  key: 0,
  class: "w-full h-full absolute top-0 left-0 right-0 bottom-0 bg-red overflow-hidden z-50"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { id: "excel-export" }, null, -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Export", -1))
const _hoisted_14 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"15%"}
}
const _hoisted_15 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"14%"}
}
const _hoisted_16 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"14%"}
}
const _hoisted_17 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"14%"}
}
const _hoisted_18 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"15%"}
}
const _hoisted_19 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"14%"}
}
const _hoisted_20 = {
  class: "bg-white opacity-100 z-40",
  style: {"width":"14%"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "text-center text-darkText text-lg px-4 mt-32 font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_vue_excel_xlsx = _resolveComponent("vue-excel-xlsx")!
  const _component_TableGhost = _resolveComponent("TableGhost")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, { title: "manualChanges.title" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SearchInput, {
                modelValue: _ctx.searchValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                placeholder: _ctx.$t('placeholders.entitySearch')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilter = true)),
              class: "border border-inputBorder w-42 h-42"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_BaseIcon, { name: "filter" })
              ])
            ]),
            (_ctx.showFilter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_FilterPanel, {
                    filters: _ctx.filters,
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilter = false)),
                    onFetchData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onExpandPanelClick($event)))
                  }, null, 8, ["filters"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.exportLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9))
            : _createCommentVNode("", true),
          _createVNode(_component_vue_excel_xlsx, {
            data: _ctx.data,
            columns: _ctx.columns,
            "file-name": 'workshift-report',
            "file-type": 'xlsx',
            "sheet-name": 'sheetname'
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createElementVNode("button", {
                disabled: _ctx.exportLoading,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTableToExcel($event))),
                class: "flex items-center primary px-4 py-2.5 w-140 justify-center"
              }, [
                (!_ctx.exportLoading)
                  ? (_openBlock(), _createBlock(_component_BaseIcon, {
                      key: 0,
                      name: "file-white"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.exportLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                  : _createCommentVNode("", true),
                _hoisted_13
              ], 8, _hoisted_11)
            ]),
            _: 1
          }, 8, ["data", "columns"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "px-5 tableFixHead",
      style: _normalizeStyle({height: _ctx.height + 'px'})
    }, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('table.userName')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('table.entityName')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('table.createdAt')), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('table.entityType')), 1),
            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('table.fieldName')), 1),
            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('table.oldValue')), 1),
            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('table.newValue')), 1)
          ])
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manualChanges, (manualChange, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i + 'manual-change'
                }, [
                  _createElementVNode("td", null, _toDisplayString(manualChange.owner?.username ?? ''), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.entityName), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.createdAtFormatted), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.entityType), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.fieldName), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.oldValue), 1),
                  _createElementVNode("td", null, _toDisplayString(manualChange.newValue), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_TableGhost, {
              key: 1,
              "col-margin": "my-0",
              row: 10,
              col: 6
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.manualChanges.length && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t('validation.noItemsToShow')), 1))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.pagination && _ctx.pagination.totalItems)
      ? (_openBlock(), _createBlock(_component_Pagination, {
          key: 0,
          current: _ctx.current,
          total: _ctx.pagination.totalItems,
          "page-range": 2,
          "per-page": _ctx.pagination.pageSize,
          onPageChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.current = $event)),
          "text-before-input": "Go to page"
        }, null, 8, ["current", "total", "per-page"]))
      : _createCommentVNode("", true)
  ], 64))
}